import deposito_model from './deposito_model';

export default {
  Codigo: null,
  Descripcion: '',
  CodigoDeposito: '',
  CodigoAdicional: '',
  Clave: '',
  Deposito: [{ ...deposito_model }],
};
